import React from 'react';
import { styled } from '@compiled/react';
import QuestionCircleIcon from '@atlaskit/icon/core/migration/question-circle';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';

type Props = {
	message: string;
	testId?: string;
};

const HelpIcon = ({ message, testId }: Props) => (
	<Tooltip content={message} position="right">
		<HelpIconContainer data-test-id={testId}>
			<QuestionCircleIcon color={token('color.icon')} LEGACY_size="small" label="" />
		</HelpIconContainer>
	</Tooltip>
);

export default HelpIcon;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const HelpIconContainer = styled.div({
	width: '16px',
	height: '16px',
});
